<!-- ================优质资源====================-->
<template>
    <div class="premium-resource-page">
        <home-head />
        <div class="premium-resource-body">
            <div class="premium-resource-inner">
                <!-- 标题区 -->
                <div class="premium-resource-header">
                    <div class="premium-resource-title-box">
                        <div class="premium-resource-title">优质资源</div>
                        <div class="premium-resource-subtitle">分龄资源 &nbsp;可看可下</div>
                    </div>
                    <div class="premium-resource-actions">
                        <div class="back-btn" @click="goHome">
                            <span>返回首页</span>
                        </div>
                    </div>
                </div>

                <!-- 标签切换 -->
                <div class="premium-resource-tabs">
                    <div class="tab-item" 
                         v-for="tab in tabs" 
                         :key="tab.value"
                         :class="{ active: activeTab === tab.value }"
                         @click="handleTabChange(tab.value)">
                        {{ tab.label }}
                    </div>
                </div>

                <!-- 筛选工具栏 -->
                <div class="premium-resource-filter">
                    <div class="filter-left">
                        <div class="filter-item">
                            <span class="filter-label">学段</span>
                            <el-select class="filter-select" v-model="currentQuery.periodKey" clearable placeholder="请选择" @change="changePeriod">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div>
                        <div class="filter-item">
                            <span class="filter-label">年级</span>
                            <el-select class="filter-select" v-model="currentQuery.gradeKey" clearable placeholder="请选择" @change="changeGrade">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div>
                        <div class="filter-item" v-if="activeTab !== 'courseware'">
                            <span class="filter-label">学科</span>
                            <el-select class="filter-select" v-model="currentQuery.subjectKey" clearable placeholder="请选择" @change="handleFilterChange">
                                <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div>
                    </div>
                    <div class="filter-right">
                        <input class="search-input" type="text" placeholder="请输入关键词" v-model="currentQuery.searchKey" @keyup.enter="handleSearch" />
                        <div class="search-btn" @click="handleSearch">搜索</div>
                    </div>
                </div>

                <!-- 列表内容区（可滚动） -->
                <div class="list-content" v-loading="loading">
                    <!-- 高水平示范课 / 人工智能 列表（每行3个） -->
                    <div class="course-list three-col" v-if="activeTab !== 'courseware'">
                        <div class="course-card" v-for="item in currentList" :key="item.courseId" @click="handleCourseClick(item)">
                            <div class="course-title" :title="item.courseName">{{ item.courseName }}</div>
                            <div class="course-body">
                                <div class="course-cover">
                                    <img class="img-100" :src="item.courseCover" :alt="item.courseName" />
                                </div>
                                <div class="course-info">
                                    <div class="info-row">{{ formatCourseRange(item) }}</div>
                                    <div class="info-row">主讲人：{{ item.teacherName || '--' }}</div>
                                    <div class="info-row">课程类型：{{ item.courseTypeName || currentTabName }}</div>
                                    <div class="info-row stats">
                                        <span class="stat-item">
                                            <el-icon class="stat-icon"><Pointer /></el-icon>
                                            {{ item.likeCount || 0 }}
                                        </span>
                                        <span class="stat-item">
                                            <el-icon class="stat-icon"><Star /></el-icon>
                                            {{ item.collectCount || 0 }}
                                        </span>
                                        <span class="stat-item">
                                            <el-icon class="stat-icon"><View /></el-icon>
                                            {{ item.viewCount || 0 }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 互动课件 列表（每行4个，无右侧信息区） -->
                    <div class="courseware-list four-col" v-if="activeTab === 'courseware'">
                        <div class="courseware-card" v-for="item in currentList" :key="item.coursewareId" @click="handleCoursewareClick(item)">
                            <div class="courseware-cover">
                                <img class="img-100" :src="item.cover" :alt="item.name" />
                            </div>
                            <div class="courseware-title" :title="item.name">{{ item.name }}</div>
                        </div>
                    </div>

                    <!-- 暂无数据 -->
                    <div class="empty-state" v-if="!loading && currentList.length === 0">
                        <div class="empty-icon">
                            <img src="@/assets/image/data_empty.png" alt="暂无数据" />
                        </div>
                        <div class="empty-text">暂无数据</div>
                    </div>
                </div>

                <!-- 分页 -->
                <div class="pagination-wrapper" v-if="currentTotal > 0">
                    <pagination :background="false" 
                        :pageSizes="activeTab === 'courseware' ? [8, 12, 16] : [9, 18, 27]" 
                        :total="currentTotal"
                        v-model:page.sync="currentQuery.pageNum" 
                        v-model:limit.sync="currentQuery.pageSize" 
                        @pagination="loadCurrentData" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { pageFamousCourses } from "@/api/admin/course";
import { pageCourseware } from "@/api/admin/courseware";
import { queryDict } from "@/api/admin/dict";
import homeHead from "@/components/common/homeHead.vue";

export default {
    name: "premiumResource",
    components: { homeHead },
    data() {
        return {
            activeTab: "famous",
            tabs: [
                { label: "高水平示范课", value: "famous" },
                { label: "互动课件", value: "courseware" },
                { label: "人工智能", value: "ai" },
            ],
            loading: false,
            periodList: [],
            gradeList: [],
            subjectList: [],
            dictTree: [],
            // 各模块独立查询参数
            queryParams: {
                famous: {
                    searchKey: "",
                    courseName: "",
                    periodKey: "",
                    gradeKey: "",
                    subjectKey: "",
                    stageType: '1',
                    courseType: "1",
                    status:1,
                    pageNum: 1,
                    pageSize: 9,
                },
                courseware: {
                    searchKey: "",
                    coursewareName: "",
                    periodKey: "",
                    gradeKey: "",
                    pageNum: 1,
                    pageSize: 8,
                },
                ai: {
                    searchKey: "",
                    courseName: "",
                    periodKey: "",
                    gradeKey: "",
                    subjectKey: "",
                    status:1,
                    stageType: '5',
                    courseType: "1",
                    pageNum: 1,
                    pageSize: 9,
                },
            },
            totals: {
                famous: 0,
                courseware: 0,
                ai: 0,
            },
            dataMap: {
                famous: [],
                courseware: [],
                ai: [],
            },
        };
    },
    computed: {
        currentQuery() {
            return this.queryParams[this.activeTab];
        },
        currentList() {
            return this.dataMap[this.activeTab];
        },
        currentTotal() {
            return this.totals[this.activeTab];
        },
        currentTabName() {
            const tab = this.tabs.find(item => item.value === this.activeTab);
            return tab ? tab.label : "";
        },
    },
    watch: {
        "$route.query": {
            handler(newQuery) {
                if (!newQuery || this.isQuerySameAsCurrent(newQuery)) return;
                this.restoreFromQuery(newQuery);
            },
        },
    },
    created() {
        this.handleQueryDict();
    },
    mounted() {},
    methods: {
        /* ===============字典查询===================== */
        handleQueryDict() {
            queryDict({ code: "lession_xd_nj_xk" }).then(res => {
                if (res.data.code === 1) {
                    this.dictTree = res.data.data || [];
                    this.periodList = this.dictTree;
                }
                this.restoreFromQuery();
            });
        },

        /* ===============根据学段/年级刷新下拉选项===================== */
        refreshDictOptions() {
            this.gradeList = [];
            this.subjectList = [];
            const periodKey = this.currentQuery.periodKey;
            const gradeKey = this.currentQuery.gradeKey;
            if (!periodKey || !this.dictTree.length) return;
            const period = this.dictTree.find(p => p.dictKey === periodKey);
            if (!period) return;
            this.gradeList = period.childrenList || [];
            if (!gradeKey) return;
            const grade = this.gradeList.find(g => g.dictKey === gradeKey);
            if (grade) this.subjectList = grade.childrenList || [];
        },

        /* ===============判断 URL 查询是否与当前状态一致===================== */
        isQuerySameAsCurrent(query) {
            const q = query || {};
            const tab = q.tab || "famous";
            if (tab !== this.activeTab) return false;
            const params = this.currentQuery;
            const fields = ["searchKey", "periodKey", "gradeKey", "subjectKey"];
            for (const f of fields) {
                const qv = q[f] === undefined || q[f] === null || q[f] === "" ? undefined : String(q[f]);
                const pv = params[f] === undefined || params[f] === null || params[f] === "" ? undefined : String(params[f]);
                if (qv !== pv) return false;
            }
            const pageNum = Number(q.pageNum) || 1;
            const pageSize = Number(q.pageSize) || (this.activeTab === "courseware" ? 8 : 9);
            if (pageNum !== Number(params.pageNum)) return false;
            if (pageSize !== Number(params.pageSize)) return false;
            return true;
        },

        /* ===============将当前查询条件同步到 URL===================== */
        syncQueryToUrl() {
            const params = this.currentQuery;
            const query = { ...this.$route.query };
            query.tab = this.activeTab;
            const setQuery = (key, value) => {
                if (value !== undefined && value !== null && value !== "") {
                    query[key] = value;
                } else {
                    delete query[key];
                }
            };
            setQuery("searchKey", params.searchKey);
            setQuery("periodKey", params.periodKey);
            setQuery("gradeKey", params.gradeKey);
            setQuery("subjectKey", params.subjectKey);
            query.pageNum = params.pageNum;
            query.pageSize = params.pageSize;
            this.$router.replace({ query }).catch(() => {});
        },

        /* ===============从 URL 查询中恢复查询条件===================== */
        restoreFromQuery(query = this.$route.query) {
            const q = query || {};
            const tab = q.tab;
            if (tab && this.tabs.some(t => t.value === tab)) {
                this.activeTab = tab;
            }
            const params = this.currentQuery;
            const fields = ["searchKey", "periodKey", "gradeKey", "subjectKey"];
            fields.forEach(key => {
                if (q[key] !== undefined && q[key] !== null) {
                    params[key] = q[key];
                }
            });
            params.pageNum = Number(q.pageNum) || 1;
            params.pageSize = Number(q.pageSize) || (this.activeTab === "courseware" ? 8 : 9);
            this.refreshDictOptions();
            this.loadCurrentData();
        },

        /* ===============学段切换===================== */
        changePeriod() {
            this.currentQuery.gradeKey = "";
            this.currentQuery.subjectKey = "";
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.currentQuery.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            });
            this.handleFilterChange();
        },

        /* ===============年级切换===================== */
        changeGrade() {
            this.currentQuery.subjectKey = "";
            this.subjectList = [];
            this.periodList.forEach(e => {
                if (this.currentQuery.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.currentQuery.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    });
                }
            });
            this.handleFilterChange();
        },

        /* ===============筛选变化===================== */
        handleFilterChange() {
            this.currentQuery.pageNum = 1;
            this.loadCurrentData();
        },

        /* ===============搜索===================== */
        handleSearch() {
            this.currentQuery.pageNum = 1;
            this.loadCurrentData();
        },

        /* ===============标签切换===================== */
        handleTabChange(tabValue) {
            if (this.activeTab === tabValue) return;
            this.activeTab = tabValue;
            this.refreshDictOptions();
            // 切换模块时同步到 URL，返回后仍能保持选中及查询条件
            this.syncQueryToUrl();
            // 切换模块时若未加载过数据则自动加载
            if (this.currentList.length === 0 && this.currentTotal === 0) {
                this.loadCurrentData();
            }
        },

        /* ===============加载当前模块数据===================== */
        loadCurrentData(e) {
            if (e) {
                this.currentQuery.pageNum = e.page;
                this.currentQuery.pageSize = e.limit;
            }
            this.syncQueryToUrl();
            if (this.activeTab === "courseware") {
                this.loadCoursewareData();
            } else {
                this.loadCourseData();
            }
        },

        /* ===============课程数据查询（高水平示范课 / 人工智能）===================== */
        loadCourseData() {
            this.loading = true;
            const params = this.queryParams[this.activeTab];
            // 根据搜索框输入设置对应名称字段
            const query = { ...params };
            query.courseName = query.searchKey;
            delete query.searchKey;
            pageFamousCourses(query).then(res => {
                if (res.data.code === 1) {
                    this.dataMap[this.activeTab] = res.data.data.list || [];
                    this.totals[this.activeTab] = res.data.data.total || 0;
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        /* ===============课件数据查询===================== */
        loadCoursewareData() {
            this.loading = true;
            const params = this.queryParams.courseware;
            const query = { ...params };
            query.name = query.searchKey;
            delete query.searchKey;
            pageCourseware(query).then(res => {
                if (res.data.code === 1) {
                    this.dataMap.courseware = res.data.data.list || [];
                    this.totals.courseware = res.data.data.total || 0;
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        /* ===============格式化学段-年级-学科===================== */
        formatCourseRange(item) {
            const parts = [];
            if (item.periodName) parts.push(item.periodName);
            if (item.gradeName) parts.push(item.gradeName);
            if (item.subjectName) parts.push(item.subjectName);
            return parts.length > 0 ? parts.join("-") : "--";
        },

        /* ===============跳转===================== */
        goHome() {
            this.$router.push("/museum/home");
        },
        handleCourseClick(item) {
            this.$router.push({
                path: "/premium/courseInfo",
                query: { courseId: item.courseId, collectType: this.activeTab === "ai" ? 3 : 1 },
            });
        },
        handleCoursewareClick(item) {
            this.$router.push({
                path: "/premium/coursewareInfo",
                query: { coursewareId: item.coursewareId, collectType: 2 },
            });
        },
    }
};
</script>

<style scoped>
.premium-resource-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.premium-resource-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.premium-resource-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px 50px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;
}

/* 标题区 */
.premium-resource-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.premium-resource-title-box {
    display: flex;
    flex-direction: column;
}

.premium-resource-title {
    font-size: 24px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 6px;
}

.premium-resource-subtitle {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

.premium-resource-actions {
    display: flex;
    align-items: center;
}

.back-btn {
    height: 36px;
    line-height: 36px;
    padding: 0 32px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

/* 标签切换 */
.premium-resource-tabs {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.tab-item {
    min-width: 110px;
    height: 36px;
    line-height: 34px;
    padding: 0 20px;
    text-align: center;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.tab-item:hover {
    background-color: #fff5f5;
}

.tab-item.active {
    background-color: #b22222;
    color: #ffffff;
    border-color: #b22222;
}

/* 筛选工具栏 */
.premium-resource-filter {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.filter-left {
    display: flex;
    align-items: center;
    gap: 20px;
}

.filter-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.filter-label {
    font-size: 15px;
    color: #4b5563;
    font-family: sans-serif;
    white-space: nowrap;
}

.filter-select {
    width: 140px !important;
}

.filter-select .el-select__wrapper {
    min-height: 36px !important;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
}

.filter-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.search-input {
    width: 240px;
    height: 34px;
    line-height: 34px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    font-family: sans-serif;
    box-sizing: border-box;
    background-color: #ffffff;
}

.search-input:focus {
    border-color: #b22222;
}

.search-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 22px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.search-btn:hover {
    background-color: #b22222;
    color: #ffffff;
}

/* 列表内容区（可滚动） */
.list-content {
    width: 100%;
    flex: 1;
    min-height: 0;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 60px;
    padding-top: 10px;
}

.list-content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.list-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

.list-content::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}

.list-content::-webkit-scrollbar-thumb:hover {
    background: #9a9a9a;
}

/* 课程列表（3列） */
.course-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
    box-sizing: border-box;
    align-content: flex-start;
}

.course-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 14px;
    cursor: pointer;
    transition: all 0.25s ease;
}

.course-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.course-title {
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    color: #1f2937;
    font-family: sans-serif;
    line-height: 1.5;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.course-body {
    width: 100%;
    display: flex;
    gap: 14px;
    flex: 1;
    min-height: 0;
}

.course-cover {
    width: 140px;
    height: 100px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
    background-color: #f3f4f6;
}

.course-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.course-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 2px 0;
}

.info-row {
    font-size: 13px;
    color: #4b5563;
    font-family: sans-serif;
    line-height: 1.6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.info-row.stats {
    display: flex;
    gap: 16px;
    align-items: center;
    margin-top: 4px;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: #6b7280;
}

.stat-icon {
    font-size: 15px;
    color: #6b7280;
}

/* 课件列表（4列，无右侧信息区） */
.courseware-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
    box-sizing: border-box;
    align-content: flex-start;
}

.courseware-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 12px;
    cursor: pointer;
    transition: all 0.25s ease;
}

.courseware-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.courseware-cover {
    width: 100%;
    aspect-ratio: 16 / 10;
    border-radius: 4px;
    overflow: hidden;
    background-color: #f3f4f6;
    margin-bottom: 12px;
}

.courseware-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.courseware-title {
    width: 100%;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    color: #1f2937;
    font-weight: 500;
    font-family: sans-serif;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
}

/* 暂无数据 */
.empty-state {
    width: 100%;
    height: 100%;
    min-height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}

.empty-icon {
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
}

.empty-icon img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

/* 分页 */
.pagination-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -10px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.pagination-wrapper .el-pagination__total {
    font-size: 13px;
    color: #6b7280;
}

.pagination-wrapper .el-pagination__jump {
    font-size: 13px;
    color: #6b7280;
}

.pagination-wrapper .el-pager li {
    font-size: 13px;
    color: #4b5563;
}

.pagination-wrapper .el-pager li.active {
    background-color: #b22222;
    color: #ffffff;
}

.pagination-wrapper .el-select .el-input__wrapper {
    height: 28px;
    min-height: 28px;
    font-size: 13px;
}

@media (max-width: 1280px) {
    .premium-resource-inner { padding: 0 20px 50px 20px; }
    .premium-resource-title { font-size: 22px; }
    .filter-left { gap: 14px; }
    .filter-select { width: 120px !important; }
    .search-input { width: 200px; }
    .course-list { gap: 16px; }
    .courseware-list { gap: 16px; }
}

@media (max-width: 1024px) {
    .premium-resource-title { font-size: 20px; }
    .premium-resource-subtitle { font-size: 13px; }
    .premium-resource-filter { flex-wrap: wrap; gap: 12px; }
    .filter-left { gap: 12px; }
    .filter-select { width: 100px !important; }
    .search-input { width: 160px; }
    .course-list { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
    .courseware-list { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
}

@media (max-width: 768px) {
    .premium-resource-header { flex-direction: column; align-items: flex-start; gap: 12px; }
    .premium-resource-tabs { flex-wrap: wrap; }
    .premium-resource-filter { flex-direction: column; align-items: flex-start; }
    .filter-left { flex-wrap: wrap; }
    .filter-right { width: 100%; }
    .search-input { flex: 1; }
    .course-list { grid-template-columns: repeat(1, minmax(0, 1fr)); gap: 10px; }
    .courseware-list { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
    .course-card { padding: 10px; }
    .course-cover { width: 120px; height: 86px; }
}
</style>
